import React from 'react';
import {
  Dialog, DialogContent, DialogActions, Button, Snackbar, IconButton, AppBar, Toolbar, Typography,
  useMediaQuery
} from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';
import DeleteIcon from '@material-ui/icons/Delete';
import SaveIcon from '@material-ui/icons/Check';
import { withTheme } from 'react-jsonschema-form';
import { Theme as MuiTheme } from 'rjsf-material-ui';
import { saveOrCreateEntity, deleteEntity } from 'services/entities';
import { toJSONSchema } from 'services/schemas';
import { MUIDateWidget,  MUIDateTimeWidget, MUITimeWidget } from 'components/Common/MUIDateTimeWidget';

const Form = withTheme(MuiTheme);

const log = (type) => console.log.bind(console, type);

const widgets = {
  DateWidget: MUIDateWidget,
  TimeWidget: MUITimeWidget,
  DateTimeWidget: MUIDateTimeWidget,
};

function JSONSchemaForm({schema, entity, formDataRef}) {
  const [ jsonSchema, setJsonSchema ] = React.useState();
  React.useEffect(() => {
    jsonSchema || toJSONSchema(schema).then(setJsonSchema);
  }, [jsonSchema, schema]);
  return !jsonSchema ? <></> : <Form schema={jsonSchema}
          formData={entity}
          widgets={widgets}
          onChange={({formData}) => formDataRef && (formDataRef.current = formData)}
          onError={log("errors")}
          >
            <>{/* skip default submit button */}</>
          </Form>
}

export function ViewEntity({schema, title, entity, onClose, canUpdate, canDelete}) {
  const formDataRef = React.useRef({});
  const [confirmDelete, setConfirmDelete] = React.useState(false);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const toJSONSchemaObject = (entity, schema) => {
    if(!entity) return entity;
    const transformedEntity = {...entity};
    schema && schema.properties.forEach(prop => {
      if(prop.type === 'comma-separated-list') {
        if(typeof entity[prop.name] === 'string') {
          transformedEntity[prop.name] = entity[prop.name].split(',');
        }
        if(prop.required && !transformedEntity[prop.name]) {
          transformedEntity[prop.name] = [''];
        }
      }
    });
    console.log({toJSONSchemaObject, entity, transformedEntity});
    return transformedEntity;
  }

  const fromJSONSchemaObject = (entity, schema) => {
    if(!entity) return entity;
    const transformedEntity = {...entity};
    schema && schema.properties.forEach(prop => {
      if(prop.type === 'comma-separated-list' && Array.isArray(entity[prop.name])) {
        transformedEntity[prop.name] = entity[prop.name].join(',');
      }
    });
    console.log({fromJSONSchemaObject, entity, transformedEntity});
    return transformedEntity;
  }

  const saveAndClose = async () => {
    const updatedEntity = fromJSONSchemaObject(formDataRef.current, schema);
    console.log({updatedEntity});
    const resp = await saveOrCreateEntity(schema.id, updatedEntity);
    console.log({resp});
    onClose({refresh: true, message: resp.userMessage});
  };

  const deleteAndClose = async () => {
    const resp = await deleteEntity(schema.id, entity.id);
    console.log({resp});
    onClose({refresh: true, message: resp.userMessage});  
  };

  const confirmAndCloseSnackbar = () => {
    deleteAndClose();
    closeSnackbar();
  };
  const closeSnackbar = () => setConfirmDelete(false);

  return <Dialog fullScreen={fullScreen} open={!!entity} onClose={onClose} aria-labelledby="form-dialog-title">
    <AppBar position="relative">
      <Toolbar>
        <IconButton edge="start" color="inherit" onClick={onClose} aria-label="close">
          <CloseIcon />
        </IconButton>
        <Typography variant="h6" noWrap={true} flex={1} spacing={1}>
          {title}
        </Typography>
      </Toolbar>
    </AppBar>
    <DialogContent>
      <JSONSchemaForm schema={schema} entity={toJSONSchemaObject(entity, schema)} formDataRef={formDataRef}/>
    </DialogContent>
    <DialogActions>
      <Button 
        onClick={() => setConfirmDelete(true)} 
        variant="contained" 
        color="primary" 
        disabled={!canDelete}
        startIcon={<DeleteIcon />}
      >
        Delete
      </Button>
      <Button 
        onClick={saveAndClose} 
        color="primary" 
        variant="contained" 
        disabled={!canUpdate}
        startIcon={<SaveIcon />}
      >
        Save
      </Button>
    </DialogActions>
    <Snackbar 
      open={confirmDelete} message="Are you sure?" onClose={closeSnackbar} 
      action={
        <>
          <Button onClick={confirmAndCloseSnackbar} variant="outlined" color="inherit">Delete</Button>
          <IconButton size="small" aria-label="close" color="inherit" onClick={closeSnackbar}>
            <CloseIcon fontSize="small" />
          </IconButton>
        </>
      }
    />
  </Dialog>;
}